import { useGetAccountQuery } from '@/services/accounts';
import { Alert, Box } from '@palmetto/palmetto-components';
import { useParams } from 'react-router-dom';

import { ProgramType } from 'types';

import { MainContainer } from '../MainContainer';

import { GeneratorPricingCalculator } from './GeneratorPricingCalculator';
import { GeothermalPricingCalculator } from './GeothermalPricingCalculator';
import { HVACPricingCalculator } from './HVACPricingCalculator';
import { SolarPricingCalculator } from './SolarPricingCalculator';
import { WaterHeaterPricingCalculator } from './WaterHeaterPricingCalculator';

export const PricingCalculatorFactory = () => {
  const { id } = useParams<{ id: any }>();
  const { data: account, isLoading: isAccountLoading } = useGetAccountQuery(id);

  if (isAccountLoading) {
    return null;
  }

  const renderCalculator = () => {
    switch (account?.programType) {
      case ProgramType.hvac:
        return <HVACPricingCalculator />;
      case ProgramType.waterHeater:
        return <WaterHeaterPricingCalculator />;
      case ProgramType.generator:
        return <GeneratorPricingCalculator />;
      case ProgramType.geothermal:
        return <GeothermalPricingCalculator />;
      default:
        return <SolarPricingCalculator />;
    }
  };

  return (
    <>
      <MainContainer as="div">
        <Box padding={{ base: '0 lg', desktop: '0' }}>
          <Alert
            variant="info"
            message="This calculator is for estimating pricing only. A quote cannot be added from here."
          />
        </Box>
      </MainContainer>
      {renderCalculator()}
    </>
  );
};
